module.exports = __webpack_public_path__ + "img/AlBayan3.c4fc34fa.jpg";